import "./style.scss";
import { FC, useEffect } from "react";
import DocumentCheckActionButtons from "@/src/components/CustomUtils/DocumentCheckActionButtons/DocumentCheckActionButtons";

export interface TasksDocumentCheckActionsPopUpProps {
  isOpen: boolean;
  onClose: () => void;
  onApprove: () => void;
  onReject: () => void;
  onToCorrect: () => void;
}

const TasksDocumentCheckActionsPopUp: FC<TasksDocumentCheckActionsPopUpProps> = ({
  isOpen,
  onClose,
  onApprove,
  onReject,
  onToCorrect,
}) => {
  useEffect(() => {
    if (!isOpen) return;

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const wrapAction = (action: () => void) => () => {
    onClose();
    action();
  };

  return (
    <>
      <button type="button" className="tasks-document-check-actions-popup-backdrop" aria-label="Close menu" onClick={onClose} />
      <div className="tasks-document-check-actions-popup-panel" role="menu">
        <DocumentCheckActionButtons
          layout="column"
          onApprove={wrapAction(onApprove)}
          onReject={wrapAction(onReject)}
          onToCorrect={wrapAction(onToCorrect)}
        />
      </div>
    </>
  );
};

export default TasksDocumentCheckActionsPopUp;
